const config = {};
export function getConfig(key) {
  return config[key];
}
export function setConfig(key, value) {
  config[key] = value;
}
